<template>
  <div class="rest-photo">
    <div style="color:#f40;margin-bottom:10px">
      *建议上传格式为.png, .jpg, .jpeg,
      .gif；尺寸为【375*210（16:9）】比例大小的图片。
    </div>
    <a-upload
      :action="actionUrl"
      list-type="picture-card"
      :file-list="fileList"
      :headers="header"
      :multiple="true"
      :data="{ dataId: dataId }"
      @preview="handlePreview"
      @change="handleChange"
      :remove="removePic"
      accept=".png, .jpg, .jpeg, .gif"
    >
      <div v-if="fileList.length < 5">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          添加图片
        </div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="房型图片" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { cache } from "@/utils/common.js";
import urls from "@/api/url";
import configs from "@/config/baseConfig";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  components: {},
  data() {
    return {
      header: "",
      previewVisible: false,
      previewImage: "",
      dataId: "",
      fileList: [
        // {
        //   uid: "-1",
        //   name: "image.png",
        //   status: "done",
        //   url:
        //     "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
        // }
      ]
    };
  },
  created() {
    const user = cache.get("user");
    if (user) {
      const token = user.Token;
      if (token) {
        this.actionUrl = this.$config.serverUrl + urls["PicSave"];
        this.header = {
          Authorization: token
        };
      }
    }
    this.getImageId().then(() => {
      this.getPicList();
    });
  },
  methods: {
    getImageId() {
      return new Promise((resolve, reject) => {
        this.$post("GetRestaurantGalleryId", {})
          .then(res => {
            this.dataId = res.Data;
            resolve(res.Data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    getPicList() {
      this.$post("GetPicPath", { Id: this.dataId }).then(res => {
        if (res.Data && res.Data.length) {
          res.Data.forEach(el => {
            this.fileList.push({
              uid: el.Id,
              name: el.Name,
              status: "done",
              url: configs.serverUrl + "/" + el.Value,
              response: {
                Data: {
                  AppointId: el.Id
                }
              }
            });
          });
        }
      });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    removePic(e) {
      this.$post("PicDelete", {
        Id: e.response.Data.AppointId
      }).then(res => {
        this.$message.success(res.Message);
      });
    },
    handleCancel() {
      this.previewVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.rest-photo {
  /deep/.ant-upload-list-picture-card .ant-upload-list-item,
  /deep/.ant-upload.ant-upload-select-picture-card {
    width: 200px;
    height: 112px;
  }
}
</style>
